import React from 'react';
import { useMutation } from '@tanstack/react-query';

import { FeedbackContext } from '@cvt/contexts';

import { cacheKeys } from '../config';
import { mediaClient } from '../client/mediaClient';


export const useMediaCrud = () => {
  const { genericErrorFeedback } = React.useContext(FeedbackContext);

  const uploadMedia = useMutation({
    mutationKey: [cacheKeys.uploadMedia],
    mutationFn: mediaClient.uploadMedia,
    onSuccess: (data) => {},
    onError: () => {
      genericErrorFeedback();
    },
  });

  return {
    uploadMedia,
  };
};
